import gameImage from '../bg-game.png';

const SplashScreen = () => (
  <div>
    <img src={gameImage} alt="game" className="Game-image" />
  </div>
);

export default SplashScreen;
